import axios from './http'
var qs = require('qs');

//首页数据回显
export function httpIndex() {
    return axios({
        url: '/client/index/index',
        method: 'post',
        headers: {
            'token': sessionStorage.getItem('token')
        },
    })
}
//公告详情
export function httpNoticeCat(id) {
    let data = {
        id
    }
    return axios({
        url: '/client/notice/notice/cat',
        method: 'post',
        headers: {
            'token': sessionStorage.getItem('token')
        },
        data: qs.stringify(data)
    })
}
//是否完善信息
export function httpIndexCheck() {
    return axios({
        url: '/client/index/index/check',
        method: 'post',
        headers: {
            'token': sessionStorage.getItem('token')
        },
    })
}